import React, { ReactNode } from 'react';
import AppContext from '../AppContext';

interface AppContextProviderProps {
    withEnglishBAL?: boolean;
    isTiktokShopActive?: boolean;
    children?: ReactNode;
}

const AppContextProvider = ({
    withEnglishBAL = false,
    isTiktokShopActive = false,
    children,
}: AppContextProviderProps) => (
    <AppContext.Provider value={{ withEnglishBAL, isTiktokShopActive }}>{children}</AppContext.Provider>
);

export default AppContextProvider;
